export default "__VITE_ASSET__e7gm5Z1F__"